"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const undirectedEdge_1 = require("../../lib/base/edges/undirectedEdge");
class SimpleUndirectedEdge extends undirectedEdge_1.UndirectedEdge {
    constructor() {
        super(...arguments);
        this.color = "black";
        this.standardColor = "black";
    }
    draw(ctx, grid) {
        let fromCoord = grid.getCoordinate(this.startNode);
        let toCoord = grid.getCoordinate(this.endNode);
        ctx.beginPath();
        if (this.color != this.standardColor) {
            ctx.lineWidth = 3;
        }
        ctx.moveTo(fromCoord[1], fromCoord[0]);
        ctx.lineTo(toCoord[1], toCoord[0]);
        ctx.strokeStyle = this.color;
        ctx.stroke();
        ctx.closePath();
    }
    setColor(color) {
        this.color = color;
    }
    getColor() {
        return this.color;
    }
    resetColor() {
        this.color = this.standardColor;
    }
}
exports.SimpleUndirectedEdge = SimpleUndirectedEdge;
